import { useState } from 'react';
import { inject, observer } from 'mobx-react';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import ButtonToolbar from 'react-bootstrap/ButtonToolbar';

import { useComponentDidMount } from 'modules/core/hooks';
import { DataTable } from 'modules/core/components/datatable';
import { Button } from 'modules/core/components/buttons';

import { clientNotificationsActions } from './store/notificationsStore';
import NotificationsControlModal from './NotificationsControlModal';

// interface NotificationsHistoryProps {
//   clientNotificationsStore?: object
//   clientId?: string
//   orderId?: string
// }

const NotificationsHistory = props => {
  const {
    clientNotificationsStore,
    clientId,
    orderId,
  } = props;

  const columns = [
    { name: 'sendingTime', title: 'Дата, время отправки', width: 200 },
    { name: 'targetRefValueName', title: 'Куда отправлено', width: 220 },
    { name: 'pushBody', title: 'Текст уведомления', width: 400 },
    {
      name: 'source',
      title: 'Источник уведомления',
      getCellValue: row => (row.orderId && 'Заявка') || (row.penaltyId && 'Штраф'),
      width: 240,
    },
    { name: 'sentCount', title: 'Попыток отправки' },
    { name: 'failedCount', title: 'Неудачные попытки' },
  ];

  const [loading, setLoading] = useState(false);
  const [showControlModal, setShowControlModal] = useState(false);

  const loadData = async () => {
    setLoading(true);
    await clientNotificationsActions.getNotificationsHistory({ clientId, orderId });
    setLoading(false);
  };

  useComponentDidMount(() => {
    loadData();
  });

  return (
    <Col md={ 12 }>
      <Row>
        <Col md={ 8 }>
          <h4 className='mb-4'>История уведомлений</h4>
        </Col>
        <Col md={ 4 }>
          { clientId && (
            <ButtonToolbar className='float-end'>
              <Button
                variant='primary'
                icon='cog'
                text='Настройка уведомлений'
                onClick={ () => setShowControlModal(true) }
              />
            </ButtonToolbar>
          ) }
        </Col>
      </Row>
      <Row>
        <Col md={ 12 }>
          <DataTable
            loading={ loading }
            data={ clientNotificationsStore?.history }
            columns={ columns }
            localSorting
            localPaging
            hideToolbar
          />
        </Col>
      </Row>

      { clientId && (
        <NotificationsControlModal
          show={ showControlModal }
          clientId={ clientId }
          onClose={ () => setShowControlModal(false) }
        />
      ) }
    </Col>
  );
};

export default inject('clientNotificationsStore')(observer(NotificationsHistory));
